import { Link } from "react-router-dom";

/**
 * RegulatoryAlert — thin editorial strip surfaced at the top of the
 * homepage when a meaningful federal/state regulatory event affects
 * clients of the firm. Kept intentionally understated so it does not
 * compete with the hero: a single hairline band with kicker + headline
 * + link to the corresponding Journal advisory.
 *
 * The current alert relates to FinCEN's August 11, 2026 final rule
 * ending Corporate Transparency Act beneficial ownership reporting for
 * U.S. companies and U.S. persons. Retire this component or edit its
 * props when the news cycle passes (usually 30-60 days).
 */
export default function RegulatoryAlert({
  kicker = "Regulatory Alert · August 2026",
  headline = "FinCEN Permanently Ends CTA Beneficial Ownership Reporting for U.S. Businesses.",
  ctaLabel = "Read the Advisory",
  href = "/journal/fincen-ends-cta-boi-reporting-2026",
}) {
  return (
    <section
      className="bg-navy text-ivory border-y border-brass/50"
      data-testid="regulatory-alert"
    >
      <div className="max-w-[1600px] mx-auto px-6 md:px-12 py-4 md:py-5">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3 md:gap-8">
          <div className="flex items-baseline gap-4 md:gap-6 flex-1 min-w-0">
            <span
              className="hidden md:inline-block text-[10px] uppercase tracking-[0.32em] text-brass whitespace-nowrap font-medium"
              data-testid="regulatory-alert-kicker"
            >
              {kicker}
            </span>
            <span
              className="md:hidden text-[9px] uppercase tracking-[0.28em] text-brass font-medium"
              data-testid="regulatory-alert-kicker-mobile"
            >
              {kicker}
            </span>
            <span
              className="font-cormorant italic text-lg md:text-xl leading-snug text-ivory/95 truncate"
              data-testid="regulatory-alert-headline"
            >
              {headline}
            </span>
          </div>
          <Link
            to={href}
            className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.28em] text-brass hover:text-ivory transition-colors whitespace-nowrap border-b border-brass/50 hover:border-ivory pb-0.5 self-start md:self-auto"
            data-testid="regulatory-alert-cta"
          >
            {ctaLabel} <span aria-hidden>&rarr;</span>
          </Link>
        </div>
      </div>
    </section>
  );
}
